import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import type { css } from 'styled-components';

import type { IconDefinition } from '@sorare/core/src/atoms/icons';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { BodyM } from '@sorare/core/src/atoms/typography';
import type { VirtualToggleFilter } from '@sorare/core/src/lib/filters';

import { SegmentButton } from '#src/searchCards/Segment/ui.tsx';

import { useVirtualFilterSegment } from './useVirtualFilterSegment.ts';

type Props = {
  filter: VirtualToggleFilter;
  cleanableFilters?: VirtualToggleFilter[];
  needsLogin?: boolean;
  onClick?: (b: boolean) => void;
  icon: IconDefinition | null;
  customCss?: ReturnType<typeof css>;
  withoutText?: boolean;
};

export const VirtualFilterSegment = ({
  filter,
  cleanableFilters = [],
  icon,
  customCss,
  onClick,
  needsLogin = false,
  withoutText,
}: Props) => {
  const { checked, onChange } = useVirtualFilterSegment({
    filter,
    cleanableFilters,
    needsLogin,
    onChange: onClick,
  });
  return (
    <SegmentButton
      $customCss={customCss}
      className={classNames({ checked })}
      onClick={onChange}
    >
      <BodyM bold>
        {!!icon && <FontAwesomeIcon icon={icon} />}
        {!!icon && !withoutText && ' '}
        {!withoutText && (
          <>
            {'label' in filter && <FormattedMessage {...filter.label} />}
            {'title' in filter && <FormattedMessage {...filter.title} />}
          </>
        )}
      </BodyM>
    </SegmentButton>
  );
};
